import { PIXI } from '@colonist/pixi';
import { GameColor } from '@colonist/ui-game';
export class UIGameAchievementBackgroundView extends PIXI.Graphics {
    constructor(width, height){
        super();
        this.beginFill(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6));
        this.lineStyle(1, GameColor.getColorHexValue(GameColor.Color.White), 1);
        this.drawRoundedRect(0, 0, width, height, 5);
        this.endFill();
    }
}
